import {
  Button,
  Colors,
  Text,
  TypesButton,
  Typography,
} from 'goalsetter-webapp-components';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ButtonContainer,
  Container,
  SendGoalCardContainer,
  SendGoalCardDescriptionContainer,
  SendGoalCardImageContainer,
  buttonStyle,
  titleWrapperStyle,
} from './styles';
import { Trans } from 'react-i18next';
import GoalCardImageView from 'app/components/GoalCardImageView';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { FamilyMember } from 'types/goals';
import { RoutesGs } from '../../../../router/RoutesList';
import DownloadApp from 'app/components/DownloadApp';
import { sendAnalyticsEvent } from '../../../../utils/analytics/analyticsWrapper';
import { ActionType, CategoryType } from '../../../../types/analytics/enum';
import LogoHeader from 'app/components/LogoHeader';
import { Flex } from '@mantine/core';

const SentGoalCardSuccess = () => {
  const { isMobile } = useMediaQueryGs();
  const { state } = useLocation();

  const navigate = useNavigate();

  const selectedUser = state?.selectedUser as FamilyMember;
  const selectedCard = state?.selectedCard;
  const customizeData = state?.customizeData;

  const goToSendGoalCard = () => {
    sendAnalyticsEvent(
      CategoryType.sendAnotherGoalcardButton,
      ActionType.Goalcard_FinalScreen_SendAnotherGoalcardButton,
    );
    navigate(RoutesGs.SendGift);
  };

  return (
    <Container>
      <LogoHeader />
      <Flex style={titleWrapperStyle}>
        <Trans
          i18nKey={t('sentGoalCardSuccess.title')}
          values={{
            amount: customizeData.goalsSupportTotal,
            firstName: selectedUser.firstnameWithPossesive,
          }}
          components={{
            span: (
              <Text
                type={Typography.GSH5}
                color={Colors.WHITE}
                style={{ textAlign: 'center' }}
              >
                {}
              </Text>
            ),
            parent: (
              <Text
                type={Typography.GSH3}
                color={Colors.WHITE}
                style={{ textAlign: 'center' }}
              >
                {}
              </Text>
            ),
          }}
        />
      </Flex>
      <SendGoalCardContainer isMobile={isMobile}>
        <SendGoalCardImageContainer>
          <GoalCardImageView imageURL={selectedCard.imageURL} />
        </SendGoalCardImageContainer>

        <SendGoalCardDescriptionContainer>
          <Text
            type={Typography.GSSUBTITLE1}
            color={Colors.WHITE}
          >
            {t('sentGoalCardSuccess.description', {
              firstName: selectedUser.firstname,
            })}
          </Text>
          <ButtonContainer>
            <Button
              type={TypesButton.PRIMARY}
              onClick={goToSendGoalCard}
              style={buttonStyle}
            >
              {t('sentGoalCardSuccess.sendAnother')}
            </Button>
          </ButtonContainer>
        </SendGoalCardDescriptionContainer>
      </SendGoalCardContainer>
      <DownloadApp />
    </Container>
  );
};

export default SentGoalCardSuccess;
